/**
 * @author NikolaV
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import { Dropdown } from '@shared/ui-react/Dropdown';
import { GtPointsLayer } from '@openlayers/points/GtPointsLayer';
import { Tooltip } from 'primereact/tooltip';


@observer
export class ModelsPanelToolbar extends React.Component<{
    settings: { layerOpacity: number };
    onLayerOpacityChange: (number) => void;
    pointsLayer: GtPointsLayer;
}, {}> {
    readonly labelPropNames = {
        none: __('general.none'),
        x: 'X',
        y: 'Y',
        z: 'Z',
        xyz: 'XYZ',
        code: __('js_logpoints.column_code'),
        linecode: __('js_logpoints.column_linecode'),
        surfacecode: __('js_logpoints.column_surfacecode'),
        number: __('js_logpoints.column_point_number'),
        prop_name: __('js_logpoints.column_point_name'),
    };

    render() {
        const opacity = this.props.settings.layerOpacity;
        return (
            <>
                <span style={{ marginLeft: 'auto' }}>
                    <Dropdown closeOnBodyClick={false} buttonStyle={{ paddingLeft: 10, paddingRight: 10 }} className='ik-button-secondary--subtle'>
                        <i className='iki iki-more'/>
                        <div className="no-select">
                            <div className="dropdown-list-title">{__('general.opacity')}:</div>
                            <div className="flex-row padded-half ai-center">
                                <input type="range" min={20} max={100} step={10} value={opacity}
                                       onChange={e => this.props.onLayerOpacityChange(parseInt(e.currentTarget.value))}/>
                                <strong style={{ width: '3em' }}> {opacity}%</strong>
                            </div>

                            <div className="dropdown-list-title flex-row ai-center">{__('general.settings')}:</div>
                            <ul className="dropdown-list clickable">
                                <li onClick={this.props.pointsLayer.toggleDeviations}>
                                   <input type="checkbox" checked={this.props.pointsLayer.showDeviations} readOnly/>{__('js_map.labels.show_points_deviation_vectors')}
                               </li>
                            </ul>

                            <Tooltip target=".models_point_label_icon" baseZIndex={99999}>
                                <div>{__('js_map.labels_are_shows_when_zoomed_in')}</div>
                                <div style={{ marginTop: 15 }}>{__('js_map.labels.shift_click_to_select_multiple')}</div>
                            </Tooltip>
                            <div className="dropdown-list-title flex-row ai-center">{__('js_map.points.point_label')}&nbsp;<i className="iki iki-help models_point_label_icon"/>:</div>
                            <ul className="dropdown-list clickable">
                               <li onClick={this.props.pointsLayer.toggleShowPoints}>
                                   <input type="checkbox" checked={this.props.pointsLayer.showLinePoints} readOnly/>{__('js_map.labels.show_point_info_for_lines')}
                               </li>
                                {Object.entries(this.labelPropNames).map(([prop, label]) => {
                                    return <li key={prop} onClick={e => this.setLabelProp(e, prop)} title={__('js_map.labels.shift_click_to_select_multiple')}>
                                        <input type="radio" checked={this.labelProps.includes(prop)} readOnly/>{label}
                                    </li>;
                                })}
                            </ul>
                        </div>
                    </Dropdown>
                </span>
            </>
        );
    }

    get labelProps() {
        if (this.props.pointsLayer.labelProps.length === 0) {
            return ['none'];
        }
        return this.props.pointsLayer.labelProps;
    }

    private setLabelProp = (event, prop: string) => {
        if (prop === 'none') {
            this.props.pointsLayer.setLabelProps([]);
        } else {
            if (event.altKey || event.shiftKey || event.ctrlKey) {
                this.props.pointsLayer.toggleLabelProp(prop);
            } else {
                this.props.pointsLayer.setLabelProps(prop);
            }
        }
    }
}
